import type { API } from 'api/config/types';
import type { Game } from 'chessboard/model/game/types';

export namespace CustomTimestamps {
  export interface API {
    get: (index?: number) => (Timestamp | undefined)[] | (Timestamp | undefined);
    set: (timestamp: number, index: number) => API.Response | null;
    setMany: (newTimestamps: number[]) => void;
  }

  export type Timestamp = number | null;

  export type Node = Game.Move.Node;

  export const enum Units {
    Milliseconds = 'Milliseconds',
    Deciseconds = 'Deciseconds',
    Seconds = 'Seconds',
  }
}
